import { ApolloError } from "@apollo/client"
import GetEnvironment from "../enviroments"

export const exceptionFromApolloError = (apolloError: ApolloError) => {
  console.log("Converting error!")
  console.log("Error: ")
  console.log(JSON.stringify(apolloError))
  console.log("Network Error: ")
  console.log(JSON.stringify(apolloError.networkError))

  if (apolloError.networkError) {
    const networkError = apolloError.networkError as any
    if (networkError.statusCode) {
      return new Error(
        `Network Error when calling GraphQL. Status Code: ${networkError.statusCode}, Description: ${networkError.bodyText}`
      )
    } else {
      return new Error(
        `GraphQL is unreachable through the network. Check the URL in the browser to troubleshoot (${
          GetEnvironment().quadriGraphQlUrl
        })`
      )
    }
  } else {
    return new Error(
      `Exception in GraphQL when processing the request. Message: ${apolloError.message}. See network trace for more info.`
    )
  }
}
